import getApiUrl from 'src/config/api';
import { prepareConfigurablePosition } from 'src/modules/Order/utils';
import ApiError from 'src/utils/error';
import { ACTION_TYPES } from './constants';

export const setActiveCategory = (id, isAutoUpdateDisabled = false, scroll = false) => async (dispatch) => {
    dispatch({
        type: ACTION_TYPES.SET_ACTIVE_CATEGORY,
        payload: { id, isAutoUpdateDisabled, scroll }
    });
};

export const enableAutoUpdateMenuCategory = () => async (dispatch) => {
    dispatch({
        type: ACTION_TYPES.ENABLE_AUTO_UPDATE_ACTIVE_CATEGORY
    });
};

export const enableAutoUpdateMenu = () => async (dispatch) => {
    dispatch({
        type: ACTION_TYPES.ENABLE_AUTO_UPDATE_ACTIVE_MENU
    });
};

export const fetchMenuPositionDetails = ({ context, menuId, categoryId, positionId }) => async (dispatch) => {
    const { restaurantId } = context;

    await fetch(`${getApiUrl()}/api/client/restaurants/${restaurantId}/menus/${menuId}/categories/${categoryId}/positions/${positionId}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }).then((response) => {
        if (response.ok) {
            return response.json();
        } else {
            return response.json().then((json) => { throw new ApiError(json); });
        }
    }).then((response) => {
        dispatch({
            type: ACTION_TYPES.MENU_POSITION_DETAILS_FETCHED,
            payload: prepareConfigurablePosition(response)
        });
    }).catch((error) => {
        dispatch({
            type: ACTION_TYPES.MENU_POSITION_DETAILS_FETCH_DAILED,
            payload: error?.firstMessage
        });
    });
};
